import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MapPin, X } from "lucide-react";
import { api } from "../lib/api";

const KEY = "tew_geo_notice";

// Slim strip for visitors outside the UK — we only build in London & the South East.
// Never blocks anything (search crawlers must still reach every page).
export function GeoNotice() {
  const loc = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (loc.pathname.startsWith("/admin")) return;
    const cached = sessionStorage.getItem(KEY);
    if (cached) { setShow(cached === "show"); return; }
    api.get("/public/geo").then(r => {
      const abroad = r.data?.known && r.data?.uk === false;
      sessionStorage.setItem(KEY, abroad ? "show" : "hide");
      setShow(abroad);
    }).catch(() => sessionStorage.setItem(KEY, "hide"));
  }, [loc.pathname]);
  if (!show || loc.pathname.startsWith("/admin")) return null;
  return (
    <div data-testid="geo-notice" className="bg-[#FBF7EF] border-b border-[#E9D9B8] text-[#12263A] text-xs sm:text-sm">
      <div className="px-4 sm:px-6 md:px-12 lg:px-16 py-2 flex items-center justify-center gap-2 text-center">
        <MapPin size={14} className="text-[#C79A3B] shrink-0" />
        <span>
          <b>UK only:</b> we design and build extensions in <b>London &amp; the South East of England</b> (Surrey, Hampshire &amp; Berkshire) — we can&rsquo;t quote for projects outside the UK.
        </span>
        <button type="button" data-testid="geo-notice-dismiss" onClick={() => { sessionStorage.setItem(KEY, "hide"); setShow(false); }}
          className="ml-2 p-1 text-[#6B7280] hover:text-[#12263A]" aria-label="Dismiss"><X size={14} /></button>
      </div>
    </div>
  );
}
